import * as yup from "yup";
import { NapVatStatus } from "../../../../common/enums";

export const myNapSettingsFormSchema = yup.object({
  vatStatus: yup.mixed<NapVatStatus>().nullable().defined(),
  merchantEik: yup
    .string()
    .trim()
    .required("ЕИК е задължителен")
    .max(50, "ЕИК може да е до 50 символа"),
  shopUin: yup
    .string()
    .trim()
    .required("УИН е задължителен")
    .max(50, "УИН може да е до 50 символа"),
  shopDomain: yup
    .string()
    .trim()
    .required("Домейнът е задължителен")
    .max(200, "Домейнът може да е до 200 символа"),
  vposNumber: yup
    .string()
    .trim()
    .nullable()
    .defined()
    .max(50, "Номерът на ВПОС може да е до 50 символа"),
});

export type IMyNapSettingsFormModel = yup.InferType<typeof myNapSettingsFormSchema>;

export const myNapSettingsFormDefaultValues: IMyNapSettingsFormModel = {
  vatStatus: NapVatStatus.NotRegistered,
  merchantEik: "",
  shopUin: "",
  shopDomain: "",
  vposNumber: null,
};
